/** Evento global para mostrar toasts de sesión sin Context ni dependencias extra */
export const SESSION_TOAST_EVENT = 'aaz-session-toast';

export function showSessionToast(message, options = {}) {
    if (typeof window === 'undefined' || !message) return;
    window.dispatchEvent(
        new CustomEvent(SESSION_TOAST_EVENT, {
            detail: { message, durationMs: options.durationMs },
        })
    );
}

function normalizeLang(lang) {
    if (!lang) return 'en';
    const l = String(lang).toLowerCase();
    if (l === 'de' || l === 'deutsch' || l === 'german') return 'de';
    return 'en';
}

export function signedInMessage(lang) {
    return normalizeLang(lang) === 'de'
        ? 'Sie sind erfolgreich angemeldet.'
        : 'You have successfully signed in.';
}

export function signedOutMessage(lang) {
    return normalizeLang(lang) === 'de'
        ? 'Sie wurden abgemeldet.'
        : 'You have been signed out.';
}

export function sessionExpiredMessage(lang) {
    return normalizeLang(lang) === 'de'
        ? 'Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.'
        : 'Your session has expired. Please sign in again.';
}

export function dictionaryPaymentSuccessMessage(lang) {
    return normalizeLang(lang) === 'de'
        ? 'Zahlung erfolgreich. Ihre vorherige Sitzung wurde beendet. Bitte melden Sie sich erneut an, um auf alle Inhalte zuzugreifen.'
        : 'Payment successful. Your previous session has ended. Please sign in again to access all content.';
}

export function showDictionaryPaymentSuccessToast(lang) {
    showSessionToast(dictionaryPaymentSuccessMessage(lang), { durationMs: 9000 });
}

export function showSignedInToast(lang) {
    showSessionToast(signedInMessage(lang));
}

export function showSignedOutToast(lang) {
    showSessionToast(signedOutMessage(lang));
}
